import React, { useEffect } from "react";
import useProjectsForInvestmentDropdown from "../../../hooks/useProjectsForInvestmentDropdown";
import { useFormikContext } from "formik";
import { Typography, TextField, MenuItem } from "@mui/material";
import { AddInvestmentFormValues } from "../../../types";
import useMediaQuery from "@mui/material/useMediaQuery";

const ProjectDropdown = () => {
  const { projects, loading, error } = useProjectsForInvestmentDropdown();
  const isMobile = useMediaQuery("(max-width:1110px)");
  const {
    setFieldValue,
    values,
    errors,
    touched,
    setFieldTouched,
    validateField,
  } = useFormikContext<AddInvestmentFormValues>();

  useEffect(() => {
    if (touched["project-name"]) {
      validateField("project-name");
    }
  }, [values, validateField, touched]);

  const handleProjectChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const selectedProject = projects.find(
      (project) => project.name === event.target.value,
    );

    await Promise.all([
      setFieldValue("project-name", event.target.value),
      setFieldValue("unit", selectedProject ? selectedProject.unit : ""),
      setFieldValue("id", selectedProject ? selectedProject.id : ""),
    ]);

    setFieldTouched("project-name", true);
    if (selectedProject) {
      validateField("unit");
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  const hasProjects = projects.length > 0;
  if (!hasProjects) {
    return (
      <Typography sx={{ paddingBottom: 4 }} align="left" variant="h6">
        No Projects found
      </Typography>
    );
  }

  return (
    <>
      <TextField
        id="investment-projects"
        name="project-name"
        label="Project name"
        size="small"
        color="secondary"
        autoComplete="off"
        select
        value={values["project-name"]}
        onChange={handleProjectChange}
        error={touched["project-name"] && Boolean(errors["project-name"])}
        helperText={touched["project-name"] && errors["project-name"]}
        sx={{
          width: isMobile ? "100%" : "70%",
          marginBottom: isMobile ? "20px" : 0,
          "& .MuiFormHelperText-root": {
            marginLeft: 0,
            marginRight: 0,
          },
        }}
      >
        {projects.map((project) => (
          <MenuItem key={project.id} value={project.name}>
            {project.name}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
};

export default ProjectDropdown;
